import { allowDevTools } from 'utils/config';

import DevTabs from './DevTabs';
import SeoHelper from './SeoHelper';

const isDevelopment = allowDevTools;

const DevTools = () => {
  return (
    <>
      <DevTabs />

      {isDevelopment && <SeoHelper />}
    </>
  );
};

export default DevTools;
